<template>
  <div class="pg_wrap">
    <a @click="onPageChange(0)" class="pg_page pg_first" style="cursor: pointer;">맨처음</a>
    <a @click="onPageChange(currentPage - 1)" class="pg_page pg_prev" style="cursor: pointer;">이전</a>
    
    <a v-for="(paging, index) in pages" :key="index"
       :class="paging - 1 === currentPage ? 'pg_current' : 'pg_page'"
       @click="onPageChange(paging - 1)" style="cursor: pointer;">
      {{ paging }}
    </a>
    
    <a @click="onPageChange(currentPage + 1)" class="pg_page pg_next" style="cursor: pointer;">다음</a>
    <a @click="onPageChange(totalPages -1)" class="pg_page pg_end" style="cursor: pointer;">맨끝</a>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';

const {t} = useI18n();
</script>
<script>
export default {
  props: ['page', 'currentPage', 'totalPages', 'pageChange'],
  data() {
    return {};
  },
  computed: {
    pages: function () {
      const list = [];
      for (let index = this.startPage; index <= this.endPage; index += 1) {
        list.push(index);
      }
      return list;
    },
    startPage() {
      return parseInt(this.currentPage / 5) * 5 + 1;
    },
    endPage() {
      let lastPage = parseInt(this.currentPage / 5) * 5 + 5;
      return lastPage <= this.totalPages ? lastPage : this.totalPages;
    }
  },
  methods : {
    onPageChange(val) {
      if (val < 0 || val >= this.totalPages) {
        return;
      }
      const param = {
        requestPage: val,
      };
      this.pageChange(param);
    },
  }
}
</script>
